import { Body, cn } from '@growtherapy/sprout-ui';

import type { BackgroundImageType } from '../../video-sdk/core/backgrounds';
import { type BackgroundSettings, BackgroundType } from '../../video-sdk/core/types';
import { BackgroundButton } from './BackgroundButton';

export type BackgroundThumbnailGridProps = {
  images: BackgroundImageType[];
  title: string;
  setBackgroundSettings: (backgroundSettings: BackgroundSettings) => void;
  selectedBackground?: BackgroundType;
  selectedBackgroundIndex?: number;
  backgroundsSelectionIsDisabled?: boolean;
  isMirrored: boolean;
  hasBorder?: boolean;
  isDarkTheme: boolean;
};

export function BackgroundThumbnailGrid({
  images,
  title,
  setBackgroundSettings,
  selectedBackground,
  selectedBackgroundIndex,
  backgroundsSelectionIsDisabled,
  isMirrored,
  hasBorder,
  isDarkTheme,
}: BackgroundThumbnailGridProps) {
  return (
    <>
      <Body.Small
        emphasis
        className={cn('text-small font-medium pb-2', {
          'rebrand:text-text-inverse': isDarkTheme,
        })}
        as='h3'
      >
        {title}
      </Body.Small>
      <ul className='grid grid-cols-3 gap-4 pb-3'>
        {images.map((image) => {
          return (
            <li key={image.id} className='max-h-20'>
              <BackgroundButton
                isDisabled={backgroundsSelectionIsDisabled}
                isSelected={selectedBackground === BackgroundType.IMAGE && selectedBackgroundIndex === image.id}
                isMirrored={isMirrored}
                image={image.thumb}
                altText={image.name}
                color={image.className}
                hasBorder={hasBorder}
                isDarkTheme={isDarkTheme}
                onClick={() =>
                  setBackgroundSettings({
                    backgroundType: BackgroundType.IMAGE,
                    backgroundIndex: image.id,
                  })
                }
              />
            </li>
          );
        })}
      </ul>
    </>
  );
}
